import React from "react";
import {TextField, Box} from "@mui/material";
import {useTranslation} from "react-i18next";

interface AddFeatureFlagProps {
    name?: "";
    setName: React.Dispatch<React.SetStateAction<string>>;
    description?: "";
    setDescription: React.Dispatch<React.SetStateAction<string>>;
}
const AddFeatureFlag: React.FC<AddFeatureFlagProps> = ({name, setName, description, setDescription}) => {
    const {t} = useTranslation();
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                margin: "0 auto",
            }}
        >
            <TextField
                label={t("feature_flags_page.name")}
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
            />
            <TextField
                label={t("feature_flags_page.description")}
                variant="outlined"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                fullWidth
                multiline
                rows={4}
            />
        </Box>
    );
};

export default AddFeatureFlag;
